export default __webpack_public_path__ + "static/media/img-0661-lithuania-premium-face.767845a9.png";